    export const mapPlaceTypesToKorean = (types = [], name = "") => {

        // ─── 베트남 ─────────────────────────────────────────
        if (types.includes("vietnamese_restaurant")) {
            // 국물 국수
            if (/phở|pho|퍼|포\b/i.test(name)) return "쌀국수/퍼";
            if (/bún bò huế|분보후에|bun bo hue/i.test(name)) return "분보후에";
            if (/hủ tiếu|후띠우|hu tieu/i.test(name)) return "후띠우";
            if (/bánh canh|반깐|banh canh/i.test(name)) return "반깐";
            // 비빔/볶음 국수
            if (/bún chả|분짜|bun cha/i.test(name)) return "분짜";
            if (/bún bò nam bộ|분보남보/i.test(name)) return "분보남보";
            if (/mì quảng|미꽝|mi quang/i.test(name)) return "미꽝";
            if (/mì xào|미싸오|mi xao|볶음면/i.test(name)) return "볶음면";
            // 밥 요리
            if (/cơm tấm|껌땀|com tam/i.test(name)) return "껌땀";
            if (/cơm lam|껌람|com lam/i.test(name)) return "껌람";
            // 간식/샌드위치
            if (/bánh mì|반미|banh mi/i.test(name)) return "반미";
            if (/bánh xèo|반쎄오|banh xeo/i.test(name)) return "반쎄오";
            if (/gỏi cuốn|고이꾼|goi cuon|spring roll/i.test(name)) return "월남쌈";
            return "베트남음식";
        }

        // ─── 태국 ───────────────────────────────────────────
        if (types.includes("thai_restaurant")) {
            if (/pad thai|팟타이|ผัดไทย/i.test(name)) return "팟타이";
            if (/poo pad|뿌팟퐁|crab curry|게카레/i.test(name)) return "뿌팟퐁커리";
            if (/krapow|카파오|basil|바질볶음/i.test(name)) return "팟카파오";
            if (/khao pad|카오팟|fried rice/i.test(name)) return "카오팟";
            if (/tom yum|똠얌|ต้มยำ/i.test(name)) return "똠얌";
            if (/tom kha|똠카|ต้มข่า/i.test(name)) return "똠카";
            if (/green curry|massaman|레드커리|그린커리|마사만/i.test(name)) return "태국커리";
            if (/mango|망고|sticky rice|찹쌀/i.test(name)) return "태국디저트";
            return "태국음식";
        }

        // ─── 대만 ───────────────────────────────────────────
        if (types.includes("taiwanese_restaurant")) {
            if (/牛肉麵|우육면|beef noodle/i.test(name)) return "우육면";
            if (/滷肉飯|루로우판|lu rou fan|braised pork rice/i.test(name)) return "루로우판";
            if (/雞排|지파이|chicken chop|chicken cutlet/i.test(name)) return "지파이";
            if (/小籠包|샤오롱바오|xiaolongbao|soup dumpling/i.test(name)) return "딤섬/만두";
            if (/火鍋|훠궈|hot.?pot/i.test(name)) return "훠궈";
            if (/珍珠奶茶|버블티|bubble tea|boba/i.test(name)) return "버블티/디저트";
            return "대만식";
        }

        // ─── 중국 ───────────────────────────────────────────
        // types 우선
        if (types.includes("hot_pot_restaurant")) return "훠궈/마라탕";
        if (types.includes("dim_sum_restaurant")) return "딤섬";

        if (types.includes("chinese_restaurant") || types.includes("chinese_noodle_restaurant")) {
            // 지역 요리
            if (/베이징 덕|北京鴨|peking duck|카오야/i.test(name)) return "베이징요리";
            if (/마라|麻辣|마파두부|mapo|쓰촨|四川|sichuan/i.test(name)) return "쓰촨요리";
            if (/광둥|粵菜|cantonese/i.test(name)) return "광둥요리";
            if (/상하이|上海|shanghainese/i.test(name)) return "상하이요리";
            // 면 요리
            if (/도삭면|刀削麵|dao xiao/i.test(name)) return "도삭면";
            if (/란저우|拉麵|lanzhou/i.test(name)) return "란저우라몐";
            if (/짜장|炸醬|zhajiang/i.test(name)) return "짜장면";
            if (/탄탄면|擔擔麵|dan dan/i.test(name)) return "탄탄면";
            // 훠궈/탕
            if (/훠궈|火鍋|hot.?pot/i.test(name)) return "훠궈/마라탕";
            if (/마라탕|麻辣燙|mala tang/i.test(name)) return "훠궈/마라탕";
            if (/불도장|佛跳牆/i.test(name)) return "고급중식";
            // 딤섬/만두
            if (/딤섬|点心|dim.?sum|샤오롱바오|小籠包|샤오마이|烧卖/i.test(name)) return "딤섬";
            // 볶음/튀김
            if (/깐풍기|라조기|멘보샤|탕수육|탕추/i.test(name)) return "중식볶음/튀김";
            return "중식";
        }

        // ─── 일본 ───────────────────────────────────────────
        if (types.includes("ramen_restaurant") || /라멘|ラーメン|ramen/i.test(name)) return "라멘";
        if (types.includes("tonkatsu_restaurant") || /돈카츠|とんかつ/i.test(name)) return "돈카츠";
        if (/규카츠|牛カツ/i.test(name)) return "규카츠";
        if (types.includes("yakiniku_restaurant") || /야키니쿠|焼肉/i.test(name)) return "야키니쿠";
        if (types.includes("sushi_restaurant") || /스시|초밥|寿司|sushi/i.test(name)) return "스시/일식";
        if (types.includes("tempura_restaurant") || /텐동|天丼|튀김|tempura/i.test(name)) return "텐동/튀김";
        if (/우동|うどん|udon/i.test(name)) return "우동";
        if (/소바|そば|soba/i.test(name)) return "소바";
        if (/이자카야|居酒屋|izakaya/i.test(name)) return "이자카야";
        if (types.includes("japanese_restaurant")) return "일식";

        // ─── 공통 ────────────────────────────────────────────
        if (types.some(t => ["cafe", "coffee_shop", "bakery", "dessert_shop", "ice_cream_shop"].includes(t))) return "카페/디저트";
        if (types.some(t => ["bar", "pub"].includes(t))) return "바/주점";

        return "일반";
    };